// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_ListaContasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /contas/lista_contas
 *
 * Returns a list of financial accounts (Contas_ContaRow) belonging to the
 * authenticated user's franchises, each enriched with formas_pagamento,
 * usuarios, and validation. Backed by Contas_model::lista_contas().
 */
import type { Contas_ContaRow } from './Contas_ContaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Contas_ListaContasResponseDados = Contas_ContaRow[];

export type Contas_ListaContasResponse = ApiResponse<Contas_ListaContasResponseDados>;

registerResponseContract('Contas_ListaContasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      conta_id:                       { type: 'number',  required: true },
      conta_nome:                     { type: 'string',  required: false },
      conta_status:                   { type: 'number',  required: false },
      conta_data_cadastro:            { type: 'string',  required: false },
      conta_franquia_id:              { type: 'number',  required: false },
      conta_franquia_nome:            { type: 'string',  required: false },
      conta_tipo:                     { type: 'string',  required: false },
      conta_permite_gerar_link_pagto: { type: 'number',  required: false },
      conta_provedor:                 { type: 'string',  required: false },
      conta_id_externo:               { type: 'string',  required: false },
      formas_pagamento: {
        type: 'array',
        required: false,
        items: {
          forma_pagamento_id:   { type: 'number',  required: true },
          forma_pagamento_nome: { type: 'string',  required: false },
        },
      },
      usuarios: {
        type: 'array',
        required: false,
        items: {
          usuario_id:                { type: 'string',  required: false },
          usuario_nome:              { type: 'string',  required: false },
          status:                    { type: 'number',  required: false },
          permite_lancar_pagamentos: { type: 'number',  required: false },
          permite_ver_relatorios:    { type: 'number',  required: false },
          permite_gerar_link_pagto:  { type: 'number',  required: false },
        },
      },
      validation: {
        type: 'object',
        required: false,
        fields: {
          is_complete:         { type: 'boolean', required: false },
          is_active:           { type: 'boolean', required: false },
          has_payment_methods: { type: 'boolean', required: false },
          has_users:           { type: 'boolean', required: false },
          issues:              { type: 'array',   required: false },
        },
      },
    },
  },
})
